import { connect } from 'react-redux';
import StatisticsByCountryContent from './StatisticsByCountryContent.js';
import { actions } from './StatisticsByCountryContent.actions';

const StatisticsByCountryContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByCountry?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByCountryContent);

export default StatisticsByCountryContentComponent;
